var rich_content_viewer_default = {
  "fontElementMap": "UjhM9",
  "wrapper": "mlzjh",
  "pluginContainerMobile": "-a3Ri",
  "viewer": "bl9-q",
  "android": "N6cQD",
  "rootedTraversedContent": "DcHeb",
  "atomic": "sH2Ht",
  "toolbar": "-lU56",
  "block": "Mxgu5"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
